import React from 'react'
import PropTypes from 'prop-types'

import { BuildingV2 } from 'Pages'
import ImagePlaceholder from 'Components/ImagePlaceholder'
import FavouritesWrapper from 'Components/Favourites/FavouritesWrapper'
import FavouritesSection from 'Components/Favourites/FavouritesSection'
import { FAVOURITE_TYPES } from 'Defaults/favourites'

import {
  _Title, _Address, _Distance, _BuildingPreview,
  _AddressBlock, _ListingCounts, _PreconStatus,
} from './styles'


const getDistance = (prox) => {
  if(!prox) return ''
  const dist = Number(prox.toFixed(2))
  if(prox < 1 && prox > 0) {
    return Math.round(dist * 1000) + 'm'
  }
  return Math.round(dist) + 'km'
}

const BuildingPreview = ({
  to, title, address, forSaleCount, forRentCount,
  distance, imageSrc, alt, handleClick, preConPreview, openNewTab = false, titleClass = '',
  onMouseLeave = () => {}, onHover = () => {}, customTitleCss = '', hideFavBtn = false, offer,
  building, isFavouritesPage, gaCategory, gaSource, salesStatus,
}) => (
  <_BuildingPreview
    data-test-id="buildingPreview"
    openNewTab={openNewTab}
    to={`/${to}`}
    alt={alt}
    onClick={handleClick}
    mobileModalChildren={
      // eslint-disable-next-line react/no-unstable-nested-components
      ({ closeModalPage }) => (
        <BuildingV2
          buildingId={building?.id}
          modalBuildingData={building}
          closeModalPage={closeModalPage}
        />
      )
    }
    mobileModalKey={`buildingModal-${building.id}`}
  >
    {
      !hideFavBtn && (
        <FavouritesWrapper
          buildingFav
          item={building}
          gaCategory={gaCategory}
          gaSource={gaSource}
        />
      )
    }

    <div
      onMouseLeave={onMouseLeave}
      onMouseEnter={onHover}
    >

      <ImagePlaceholder
        src={imageSrc || ''}
        alt={alt}
      />
      <div>
        <div>
          <_Title customTitleCss={customTitleCss} className={titleClass}>{title}</_Title>
        </div>
        {
          address && (
            <_AddressBlock>
              <_Address>
                {address}
              </_Address>
            </_AddressBlock>
          )
        }
        {
          (!preConPreview && offer !== 'Precon') ?
            <_ListingCounts>
              <div>{forSaleCount || 0} For Sale</div>
              <div>|</div>
              <div>{forRentCount || 0} For Rent</div>
            </_ListingCounts>
            : <_PreconStatus>{salesStatus || ''}</_PreconStatus>
        }
        {
          distance ? <_Distance>{getDistance(distance)} away</_Distance> : ''
        }
      </div>
    </div>
    {isFavouritesPage &&
      <FavouritesSection
        item={building}
        modelType={FAVOURITE_TYPES.BUILDING}
        isBuilding
      />
    }

  </_BuildingPreview>
)

BuildingPreview.propTypes = {
  to: PropTypes.string,
  title: PropTypes.string,
  address: PropTypes.string,
  forSaleCount: PropTypes.number,
  forRentCount: PropTypes.number,
  distance: PropTypes.number,
  imageSrc: PropTypes.string,
  alt: PropTypes.string,
  customTitleCss: PropTypes.string,
  handleClick: PropTypes.func,
  onMouseLeave: PropTypes.func,
  onHover: PropTypes.func,
  preConPreview: PropTypes.bool,
  openNewTab: PropTypes.bool,
  titleClass: PropTypes.string,
  hideFavBtn: PropTypes.bool,
  building: PropTypes.shape({
    id: PropTypes.number,
  }),
  isFavouritesPage: PropTypes.bool,
  gaCategory: PropTypes.string,
  gaSource: PropTypes.string,
  offer: PropTypes.string,
  salesStatus: PropTypes.string,
}
export default BuildingPreview
